import { render, staticRenderFns } from "./AntonymsPreview.vue?vue&type=template&id=63dadce1&lang=pug&"
import script from "./AntonymsPreview.vue?vue&type=script&lang=js&"
export * from "./AntonymsPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports